import { action, runInAction, observable } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import cloneDeep from 'lodash/cloneDeep';
// import isEqual from 'lodash/isEqual';
import partnerController from '../controller';
import {
  PartnerCarParkItem, CreatePartnerCarParkItem, UpdatePartnerCarParkItem,
  PartnerCarParams,
} from './partnerCarParkApi';

export interface PartnerCarParkStore {
  partnerCarPark: PartnerCarParkItem[],
  partnerCarParkByParams: PartnerCarParams,
  currentPartnerCarParkVehicle: PartnerCarParkItem | null;

  error: ErrorInterface,
}

const initialValues: PartnerCarParkStore = {
  partnerCarPark: [],
  partnerCarParkByParams: null,
  currentPartnerCarParkVehicle: null,
  error: null,
};

export const partnerCarParkStore = observable(initialValues);

export const PartnerCarParkActions = {

  async getPartnerCarPark(partnerId :string, showDeleted: boolean ) {
    PartnerCarParkActions.clearError();
    // reconciliationActions.setLoading();
    runInAction(() => {
      partnerCarParkStore.partnerCarParkByParams = { partnerId, showDeleted };
    });
    const response = await partnerController.getPartnerCarPark(partnerId,showDeleted);
    PartnerCarParkActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerCarParkStore.partnerCarPark = response?.data?.items ?? [];
      }
    });
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      partnerCarParkStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
      };
      throw errorData;
    }
  }),

  clearPartnerCarPark: action(() => {
    partnerCarParkStore.partnerCarParkByParams = null;
    partnerCarParkStore.partnerCarPark = [];
  }),

  setCurrentPartnerCarParkVehicle: action((item: PartnerCarParkItem | null) => {
    partnerCarParkStore.currentPartnerCarParkVehicle = item;
  }),

  async clearError() {
    partnerCarParkStore.error = null;
  },

  createNewCarParkVehicle: async (request: CreatePartnerCarParkItem): Promise<void> => {
    PartnerCarParkActions.clearError();
    const response = await partnerController.createNewCarParkVehicle(request);
    PartnerCarParkActions.handleError(response);
    if (!response.errorData) {
      const x = cloneDeep(partnerCarParkStore.partnerCarPark);
      x.push(response.data);
      runInAction(() => {
        partnerCarParkStore.partnerCarPark = cloneDeep(x);
      });
    }
  },

  updateCarParkVehicle: async (request: UpdatePartnerCarParkItem): Promise<void> => {
    PartnerCarParkActions.clearError();
    const response = await partnerController.updateCarParkVehicle(request);
    PartnerCarParkActions.handleError(response);
    if (!response.errorData) {
      const x = partnerCarParkStore.partnerCarPark.filter((v) => v.id !== request.id);
      x.push(response.data);
      runInAction(() => {
        partnerCarParkStore.partnerCarPark = cloneDeep(x);
      });
    }
  },

  deleteCarParkVehicle: async (id: string): Promise<void> => {
    PartnerCarParkActions.clearError();
    const response = await partnerController.deleteCarParkVehicle(id);
    PartnerCarParkActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerCarParkStore.partnerCarPark.find((v) => v.id !== id).isActive = false;
      }
    });
  },

  /* restoreDocTemplates: async (id: string): Promise<void> => {
    if (partnerTemplateStore.error) { partnerTemplateActions.clearError(); }
    const response = await partnerController.restoreDocTemplates(id);
    partnerTemplateActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerTemplateStore.docTemplates.find(v => v.id !== id).deletedDate = null;
      }
    });
  },

  setCurrentDocTemplates: action((docTemplate: DocTemplate) => {

    partnerTemplateStore.currentDocTemplates = docTemplate;
  }),

  clearCurrentDocTemplates: action(() => {

    partnerTemplateStore.currentDocTemplates = null;
  }),

  async getDocTemplateFonts() {
    partnerTemplateActions.clearError();
    const response = await partnerController.getDocTemplateFonts();
    partnerTemplateActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        partnerTemplateStore.docTemplateFonts = response.data?.items ?? [];
      }
    });
  }, */

};
